import './Application.css';
import { useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Autocomplete, Card, Select, MenuItem, Button, TextField, Radio, RadioGroup, Checkbox, FormControlLabel, Dialog } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import NCHeader from "./ncsbiheader.png";
import CountyAndRegion from "./CountyAndRegion";
import States from './States';
import agencies from './Agencies';
import counties from './Counties';
import { updateApplication } from '../../actions/portal/applications';

function App() {
  const { token, user } = useSelector(state => state.authReducer);
  const { currentApplication } = useSelector(state => state.applicationReducer);

  const [firstName, setFirstName] = useState(currentApplication.first_name);
  const [position, setPosition] = useState(currentApplication.position);
  const [workPhone, setWorkPhone] = useState(currentApplication.work_phone);
  const [city, setCity] = useState(currentApplication.city);
  const [state, setState] = useState(currentApplication.state);
  const [county, setCounty] = useState(currentApplication.county);
  const [lastName, setLastName] = useState(currentApplication.last_name);
  const [mobilePhone, setMobilePhone] = useState(currentApplication.mobile_phone);
  const [zipcode, setZipcode] = useState(currentApplication.zipcode);
  const [email, setEmail] = useState(currentApplication.email_address);
  const [agency, setAgency] = useState(currentApplication.agency_name);
  const [orgdescription, setOrgdescription] = useState(currentApplication.orgdescription);
  const [needs, setNeeds] = useState(JSON.parse(currentApplication.needs));
  const [sworn, setSworn] = useState(currentApplication.sworn ? currentApplication.sworn : false);
  const [open, setOpen] = useState(false);
  const [errors, setErrors] = useState([]);
  const [enabled, setEnabled] = useState(true);
  const [approved, setApproved] = useState(currentApplication.approved);
  const [denied, setDenied] = useState(currentApplication.denied);
  const [registrationType, setRegistrationType] = useState(currentApplication.orgdescription);
  const [region, setRegion] = useState(currentApplication.region);
  const [approvedBy, setApprovedBy] = useState(currentApplication?.approvingUser?.email ? currentApplication?.approvingUser?.email : '');
  const [approvedDate, setApprovedDate] = useState(currentApplication.approved_date ? (new Date(currentApplication.approved_date)).toDateString() : '');
  const [deniedBy, setDeniedBy] = useState(currentApplication?.denyingUser?.email ? currentApplication?.denyingUser?.email : '');
  const [deniedDate, setDeniedDate] = useState(currentApplication.denied_date ? (new Date(currentApplication.denied_date)).toDateString() : '');
  const [notes, setNotes] = useState(currentApplication.internal_notes ? currentApplication.internal_notes : '');

  const navigate = useNavigate();
  const dispatch = useDispatch();


  useEffect(() => {
    if(!currentApplication.id) {
      //navigate('/dashboard');
    }

    if (county) {
      for (let i in CountyAndRegion) {
        if (CountyAndRegion[i].includes(county)) {
          setRegion(i);
          break;
        }
      }
    }
  })

  function onSubmit(e) {
    e.preventDefault();
     
    let applicationData = {
      first_name: firstName,
      position: position,
      work_phone: workPhone,
      city: city,
      state: state,
      county: county,
      last_name: lastName,
      mobile_phone: mobilePhone,
      zipcode: zipcode,
      email_address: email,
      agency_name: agency,
      orgdescription: orgdescription,
      sworn: sworn,
      needs: JSON.stringify(needs),
      enabled: enabled,
      approved: approved,
      denied: denied,
      registration_type: registrationType,
      region: region,
      approved_by: approvedBy,
      denied_by: deniedBy,
      approved_date: approvedDate,
      denied_date: deniedDate,
      internal_notes: notes,
      editorId: user.id
    }
    dispatch(updateApplication(currentApplication.id, applicationData, token, () => {navigate('/dashboard')}));
    //superagent
    //  .put(process.env.REACT_APP_API_ENDPOINT)  
    //  .send({
    //    first_name: firstName,
    //    last_name: lastName,
    //    work_phone: workPhone,
    //    mobile_phone: mobilePhone, 
    //    city: city, 
    //    county: county,
    //    zipcode: zipcode, 
    //    state: state, 
    //    email_address: email, 
    //    agency_name: agency, 
    //    sworn: sworn, 
    //    needs: JSON.stringify(needs),
    //  })
    //  .then(resp => console.log(resp))
    //  .catch(err => console.log(err));
  }

  return (
    <div className="App">
      <Dialog width={'60%'} onClose={() => {setErrors([]); setOpen(false);}} open={open}>
        <div style={{ textAlign: 'center', padding: '40px' }}>
          {errors.map((err) => 
            <p style={{ color: 'red' }}>{err}</p>
          )}
        </div>
      </Dialog>
      <div className="Header">
        <img style={{ width: '100%' }} src={NCHeader} alt="NC Banner"/>
      </div>
      <div id={'nc-grid'} style={{ display: 'flex', alignItems: 'center', flexDirection: 'column', flexWrap: 'nowrap', gap: '10px' }}>
        <form onSubmit={onSubmit}>
          <div className='cardContainer'>
            <Card>
              <div className="cardHeader">
                ADMINISTRATION
              </div>
              <div className="formContainer">
                <div className="formLeft">
                  <div className="formRow">
                    <b className="bold-label" style={{ marginRight: '85px' }}>Registration Type </b>
                    <Select value={registrationType} onChange={(e) => {setRegistrationType(e?.target?.value); setOrgdescription(e?.target?.value)}} id="registrationType" size={'small'} style={{ width: '69%' }} className="fieldFloat">
                      {agencyOptions.map((agencyVal) => 
                        <MenuItem key={agencyVal} value={agencyVal}>{agencyVal}</MenuItem>
                      )}
                    </Select>
                  </div>
                  <div className="formRow">
                    <b className="bold-label" style={{ marginRight: '85px' }}>Region </b>
                    <Select value={region} onChange={(e) => setRegion(e?.target?.value)} id="region" size={'small'} style={{ width: '69%' }} className="fieldFloat">
                      {regionOptions.map((regionVal) => 
                        <MenuItem key={regionVal} value={regionVal}>{regionVal}</MenuItem>
                      )}
                    </Select>
                  </div>
                  <div className="formRow">
                    <b className="bold-label" style={{ marginRight: '85px' }}>Approved </b>
                    <Checkbox 
                      size={'small'} 
                      checked={approved} 
                      onChange={(e, val) => {
                        if (val) {
                          setDenied(false);
                        }
                        setApproved(val);
                      }}
                    />
                  </div>
                  <div className="formRow">
                    <b className="bold-label" style={{ marginRight: '85px' }}>Approved By </b>
                    <TextField disabled id="approvedBy" value={approvedBy} size={'small'} style={{ width: '69%' }} className="fieldFloat"/>
                  </div>
                  <div className="formRow">
                    <b className="bold-label" style={{ marginRight: '85px' }}>Approved Date </b>
                    <TextField disabled id="approvedDate" value={approvedDate}  size={'small'} style={{ width: '69%' }} className="fieldFloat"/>
                  </div>
                </div>
                <div className="formRight">
                  <div className="formRow">
                    <b className="bold-label" style={{ marginRight: '85px' }}>Enabled </b>
                    <Checkbox 
                      size={'small'} 
                      checked={enabled} 
                      onChange={(e, val) => {
                        setEnabled(val);
                      }}
                    />
                  </div>
                  <div className="formRow" style={{ visibility: 'hidden' }}>
                    <b className="bold-label" style={{ marginRight: '85px' }}>Filler</b>
                    <Select disabled id="adminFiller" size={'small'} style={{ width: '69%' }} className="fieldFloat">
                      {States.map((state) => 
                        <MenuItem key={state} value={state.abbreviation}>{state.abbreviation}</MenuItem>
                      )}
                    </Select>
                  </div>
                  <div className="formRow">
                    <b className="bold-label" style={{ marginRight: '85px' }}>Denied </b>
                    <Checkbox 
                      size={'small'} 
                      checked={denied} 
                      onChange={(e, val) => {
                        if (val) {
                          setApproved(false);
                        }
                        setDenied(val)
                      }}
                    />
                  </div>
                  <div className="formRow">
                    <b className="bold-label" style={{ marginRight: '85px' }}>Denied By </b>
                    <TextField disabled id="deniedBy" value={deniedBy} size={'small'} style={{ width: '69%' }} className="fieldFloat"/>
                  </div>
                  <div className="formRow">
                    <b className="bold-label" style={{ marginRight: '85px' }}>Denied Date </b>
                    <TextField disabled id="deniedDate" value={deniedDate} size={'small'} style={{ width: '69%' }} className="fieldFloat"/>
                  </div>
                </div>
                <div style={{ width: '100%', marginTop: '10px', marginBottom: '10px' }}>
                  <b className="bold-label" style={{ display: 'block' }}>Internal Notes</b>
                  <TextField value={notes} multiline minRows={2} onChange={(e, value) => setNotes(e.target.value)} id="notes" size={'small'} style={{ width: '70%' }} />
                </div>
              </div>
            </Card>
          </div>
          <div className='cardContainer'>
            <Card>
              <div className="cardHeader">
                CONTACT INFORMATION
              </div>
              <div className="formContainer">
                <div className="formLeft">
                  <div className="formRow">
                    <b className="bold-label" style={{ marginRight: '85px' }}>First Name </b>
                    <TextField id="firstName" value={firstName} onChange={(e) => setFirstName(e?.target?.value)} size={'small'} style={{ width: '69%' }} className="fieldFloat"/>
                  </div>
                  <div className="formRow">
                    <b className="bold-label" style={{ marginRight: '20px' }}>Position/Title/Rank</b>
                    <TextField id="position" value={position} onChange={(e) => setPosition(e?.target?.value)} size={'small'} style={{ width: '69%' }} className="fieldFloat"/>
                  </div>
                  <div className="formRow">
                    <b className="bold-label" style={{ marginRight: '74px' }}>Primary Phone</b>
                    <TextField id="workPhone" value={workPhone} onChange={(e) => setWorkPhone(e?.target?.value)} size={'small'} style={{ width: '69%' }} className="fieldFloat"/>
                  </div>
                  <div className="formRow">
                    <b className="bold-label" style={{ marginRight: '137px' }}>City</b>
                    <TextField id="city" value={city} onChange={(e) => setCity(e?.target?.value)} size={'small'} style={{ width: '69%' }} className="fieldFloat"/>
                  </div>
                </div>
                <div className="formRight">
                  <div className="formRow">
                    <b className="bold-label" style={{ marginRight: '85px' }}>Last Name </b>
                    <TextField id="lastName" value={lastName} onChange={(e) => setLastName(e?.target?.value)} size={'small'} style={{ width: '73%' }} className="fieldFloat"/>
                  </div>
                  <div className="formRow">
                    <b className="bold-label" style={{ marginRight: '60px' }}>Alternate Phone</b>
                    <TextField id="mobilePhone" placeholder={'optional'} value={mobilePhone} onChange={(e) => setMobilePhone(e?.target?.value)} size={'small'} style={{ width: '73%' }} className="fieldFloat"/>
                  </div>
                  <div className="formRow">
                    <b className="bold-label" style={{ marginRight: '110px' }}>County</b>
                    <Autocomplete 
                      options={counties} 
                      value={county} 
                      freeSolo={true} 
                      onChange={(_, value) => {setCounty(value)}} 
                      id="county" size={'small'} 
                      style={{ width: '73%', position: 'relative' }}
                      renderInput={(params) => (
                        <TextField {...params} onChange={(e) => setCounty(e?.target?.value ? '' : e.target.value)}/>
                      )}>
                    </Autocomplete>
                  </div>
                  <div className="formRow" style={{ paddingTop: '5px', top: '-5px', position: 'relative' }}>
                    <b className="bold-label" style={{ marginRight: '97px' }}>Zip Code</b>
                    <TextField id="zipcode" value={zipcode} onChange={(e) => setZipcode(e?.target?.value)} size={'small'} style={{ width: '73%' }} className="fieldFloat"/>
                  </div>
                </div>
                <div className="formRow">
                  <b className="bold-label" style={{ display: 'block' }}>State</b>
                  <Select value={state} onChange={(e) => setState(e?.target?.value)} id="state" size={'small'} style={{ width: '69%' }} className="fieldFloat">
                    {States.map((state) => 
                      <MenuItem key={state} value={state.abbreviation}>{state.abbreviation}</MenuItem>
                    )}
                  </Select>
                </div>
                <div className="formRow">
                  <b className="bold-label" style={{ display: 'block' }}>Email Address</b>
                  <TextField id="email" value={email} onChange={(e) => setEmail(e?.target?.value)} size={'small'} style={{ width: '69%' }} className="fieldFloat"/>
                </div>
              </div>
            </Card>
          </div>
          <div className='cardContainer'>
            <Card>
              <div className="cardHeader">
                AGENCY / ORGANIZATION
              </div>
              <div className="formContainer">
                <div style={{ width: '100%', marginTop: '10px', marginBottom: '10px' }}>
                  <b className="bold-label">Agency / Organization Name</b>
                  <Autocomplete 
                    options={agencies} 
                    value={agency} 
                    freeSolo={true} 
                    onChange={(_, value) => {setAgency(value)}} 
                    filterOptions={(options, state) => options.filter(a => a.startsWith(state.inputValue)).sort((a, b) => a.localeCompare(b))}
                    id="agency" size={'small'} 
                    style={{ width: '70%', left: '15%', position: 'relative' }}
                    renderInput={(params) => (
                      <TextField {...params} onChange={(e) => setAgency(e?.target?.value ? '' : e.target.value)}/>
                    )}>
                  </Autocomplete>
                </div>
                <div style={{ width: '100%', marginTop: '10px', marginBottom: '10px' }}>
                  <b className="bold-label">Identify your specialty, expertise, or interest</b>
                  <Autocomplete 
                    multiple 
                    options={needsOptions}  
                    value={needs} 
                    onChange={(_, value) => setNeeds(value)} 
                    id="needs" 
                    size={'small'} 
                    style={{ width: '70%', left: '15%', position: 'relative' }}
                    renderInput={(params) => (
                      <TextField {...params}/>
                    )}>
                  </Autocomplete>
                </div>
                <div style={{ width: '100%', marginTop: '10px', marginBottom: '10px' }}>
                  <b className="bold-label">Are you currently a Field Liaison Officer (FLO)</b>
                  <RadioGroup
                    style={{ alignContent: 'center' }}
                    value={sworn}
                    onChange={(_, val) => {setSworn(val)}}
                  >
                    <FormControlLabel value="true" control={<Radio />} label="Yes" />
                    <FormControlLabel value="false" control={<Radio />} label="No" />
                  </RadioGroup>
                </div>
              </div>
            </Card>
          </div>
          <div style={{ width: '90%', minHeight: '60px', paddingTop: '10px' }}>
            <Button variant="contained" type="submit" style={{ width: '100px', float: 'left' }} >Submit</Button>
          </div> 
        </form>
      </div>
    </div>
  );
}

const agencyOptions = ["Law Enforcement Agency", "Emergency Management Agency", "Fire EMS Agency", "Other Government Agency", "Private Sector / Organization, or Public-Private Industry"]
const needsOptions = ['Analysis (Crime, Intelligence)', 'Aviation (Drones, Airplane, Helicopter)', 'Arson', 'Bankwatch', 'Canine Detection', 'CBRNE', 'Child sexual exploitation', 'Civil Disturbance', 'Crime Scene Investigations / Forensic Analysis (includes Underwater search)', 'Criminal or Death Investigations (Polygraph)', 'Crisis Negotiation', 'Community outreach (Homeless Liaison, Resistance Education Programs)', 'Cyber', 'Executive Protection', 'Detention', 'Financial Crimes', 'Fraud / Theft / Robbery', 'Fugitive Apprehension', 'General or Specialized Instructor', 'Hazardous Devices and Explosives', 'Honor Guard', 'Human Trafficking', 'Internal Affairs / Special Investigations', 'Linguist', 'Marine (Harbor)', 'Mental Health Assistance', 'Mounted', 'Narcotics / Drug Investigations', 'NC Western NC Network', 'Organized Crime or Gangs', 'Patrol (Traffic, Bicycle, Marine, Motorcycle, DUI, Crash, Rail, Harbor)', 'Special Victims (Sexual assault, kidnapping, family violence)', 'School Safety', 'Technical Services', 'Threat Assessment', 'Special Weapons and Tactics', 'Workplace Violence', 'Other'];
const regionOptions = ['Capital District', 'Coastal District', 'Northeastern District', 'Northern Piedmont District', 'Northwestern District', 'Southeastern District', 'Southern Piedmont District', 'Western District']

export default App;
